import { User, UserData } from '@/domains/auth/domain/models/User'

const USER_STORAGE_KEY = 'auth_user'

class UserService {
  async saveUser(user: User): Promise<void> {
    const userData = user.toPlainObject()
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userData))
  }

  async getCurrentUser(): Promise<User | null> {
    try {
      const userJson = localStorage.getItem(USER_STORAGE_KEY)
      if (!userJson) return null

      const userData = JSON.parse(userJson) as UserData
      return User.fromStoredData(userData)
    } catch (error) {
      console.error('Failed to get current user', error)
      return null
    }
  }

  async clearUser(): Promise<void> {
    localStorage.removeItem(USER_STORAGE_KEY)
  }

  async hasValidUser(): Promise<boolean> {
    const user = await this.getCurrentUser()
    return user?.isValid() ?? false
  }
}

export const userService = new UserService()
